// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","inline":"Form_inline__kDExJ","vertical":"Form_vertical__MuiAa","centered":"Form_centered__qsIW8","card":"Form_card__sGwp3"};